import { contentPipeline, RenderReact } from '@doist/content-system';
import { helpCenterComponents } from '@doist/marketist';
import { rules } from 'services/content-system/blog-post/rules';
import type { Document } from '@contentful/rich-text-types';
const transform = contentPipeline({
  source: 'contentful',
  rules
});
const components = helpCenterComponents('web', () => {});
export function RenderRichText({
  children
}: {
  children: Document;
}) {
  return <RenderReact content={transform(children)} components={components} data-sentry-element="RenderReact" data-sentry-component="RenderRichText" data-sentry-source-file="render-rich-text.tsx" />;
}